<template>
  <div>
    <b-modal
      centered
      id="ModalAssociateList"
      size="sm"
      modal-class="custom-dialog dialog-600"
      hide-footer
      :title="`Asociar lista: ${formTableList.row.name}`"
      @close="close"
    >
      <form-render :form.sync="form" :fields="fields" ref="formRenderAssociateList" containerButtonsClass="col-sm-4 mt-2" :key="keyFormRender">
        <template #labelFile>
          <div>
            <p>Archivo de importación (<b-button class="p-0" variant="link" size="sm" :href="url">Descargar Formato</b-button>)</p>
          </div>
        </template>
      </form-render>
      <div class="footer-modal-coverage">
        <b-button class="float-right mt-1 mb-1" variant="outline-success" @click="ok" :disabled="loading.associateList">
          <span v-if="!loading.associateList" class="mb-1">Confirmar</span>
          <span class="mt-1 p-2" v-if="loading.associateList"><b-spinner small /> </span>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import BaseServices from '@/store/services/index'
import dayjs from 'dayjs'

export default {
  name: 'ModalAssociateList',
  props: {
    'formTableList': {
      type: Object,
      required: true
    },
    'closeModal': {
      type: Function,
      required: false
    },
    'mySession': {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      form: {},
      fields: [],
      keyFormRender: 0,
      loading: {
        associateList: false
      },
      baseService: new BaseServices(this),
      optionsRadioType: [
        { id: 1, text:  this.$t('Cargar por Ecommerce/Marketplace') },
        { id: 2, text: this.$t('Carga masiva') }
      ],
      fieldIdSeller: { fieldType: 'FieldSelect', useLabel: true, useSkeleton: false, name: 'idSeller', label: 'Ecommerce/Marketplace', containerClass: 'container-info col-12', validation: 'required', dependency: 'country', clearable: true, searchOnType: { fx: this.setSeller, nChars: 2, debounce: 600, allowSearchAsValue: false, persistSearch: true } },
      fieldMasiveCharge: { fieldType: 'FieldFileDropArea', name: 'file', validation: 'required', containerClass: 'col-12', accept: '.xlsx, .xls', classField:'hide-button-browse', labelFormFile: 'Seleccionar archivo', styleSmall: true},
      labelFile: { name: 'labelFile', useSlot: true, containerClass: 'col-12 mt-2' },
      url: 'https://storage.cloud.google.com/formato-archivos-subida-akatsuki/Formato%20Asignacion%20masiva%20lista%20de%20precios.xlsx',
      firstDaysRanges: [],
      lastDaysRanges: [],
      priceLists: [],
      companies: []
    }
  },
  methods: {
    setInitialData() {
      this.form = this.formTableList
      this.fields = [
        { fieldType: 'FieldSelect', useSkeleton: false, useLabel: true, name: 'country', disabled: true, label: 'País', containerClass: 'col-sm-12 fieldSelect', addFlags: true, validation: 'required', sort: true },
        { fieldType: 'FieldSelect', useSkeleton: false, useLabel: true, name: 'carrier', disabled: true, label: 'Courier', containerClass: 'col-sm-12', dependency: 'country', sort: true},
        { fieldType: 'FieldSelect', useSkeleton: false, useLabel: true, name: 'service', label: 'Servicio', validation: 'required', containerClass: 'col-12', dependency: 'carrier', sort: true, options: this.formTableList.servicesOptions },
        { fieldType: 'FieldDatepicker', useSkeleton: false, useLabel: true, label: 'Fecha inicio', name: 'initDate', containerClass: 'col-6', clearable: true, validation: 'requiredDate', availableDates: this.firstAndLastDays('firstDaysRanges'), change: this.changeInitDate },
        { fieldType: 'FieldDatepicker', useSkeleton: false, useLabel: true, label: 'Fecha fin real', name: 'endDate', containerClass: 'container-info col-6', clearable: true, dependency: 'initDate' },
        { fieldType: 'FieldRadio', name: 'radioTypeCharge',  align: 'h', options: this.optionsRadioType, change: this.changeRadioType, containerClass: 'col-12 mt-1 mb-1', dependency: 'country', validation: 'required'}
      ]
    },
    firstAndLastDays(name) {
      const currentDate = new Date()
      // Generar los primeros días del mes para los próximos 18 meses
      const firstDaysRanges = this.generateDateRanges(currentDate, 18, false)
      this.firstDaysRanges = firstDaysRanges

      return this[name]
    },
    lastDays(name, value) {
      if (value) {
        const initDate = new Date(value)
        // Generar los últimos días del mes después de la fecha seleccionada
        const lastDaysRanges = this.generateDateRanges(initDate, 18, true)
        // Actualizar las fechas disponibles para "Fecha fin real"
        const endDateFieldIndex = this.m_getElementIndex(this.fields, 'name', 'endDate')
        if (endDateFieldIndex !== -1) {
          this.m_setSkeletonField(this.fields, 'name', 'endDate', true)
          this.fields[endDateFieldIndex].availableDates = lastDaysRanges
          setTimeout(() => this.m_setSkeletonField(this.fields, 'name', 'endDate', false), 100)
        }
      }
    },
    generateDateRanges(startDate, monthsToGenerate, isLastDay = false) {
      const isSuperadminEditionExtention = Object.prototype.hasOwnProperty.call(this.mySession.permissions_v2, 'superadmin-edition-extention')
      const dateRanges = []
      const today = new Date()
      if (isSuperadminEditionExtention) {
        if (isLastDay) {
          // Para endDate: todas las fechas desde startDate hasta 18 meses después
          const end = new Date(startDate.getFullYear(), startDate.getMonth() + 18, startDate.getDate())
          const current = new Date(startDate)
          while (current <= end) {
            dateRanges.push({ start: new Date(current), end: new Date(current) })
            current.setDate(current.getDate() + 1)
          }
        } else {
          // Para initDate: desde 6 meses atrás hasta 18 meses después de hoy
          const start = new Date(today.getFullYear(), today.getMonth() - 6, today.getDate())
          const end = new Date(today.getFullYear(), today.getMonth() + 18, today.getDate())
          const current = new Date(start)
          while (current <= end) {
            dateRanges.push({ start: new Date(today), end: new Date(current) })
            current.setDate(current.getDate() + 1)
          }
        }
      } else {
        for (let i = 0; i < monthsToGenerate; i++) {
          const year = startDate.getFullYear()
          const month = startDate.getMonth() + i
          const day = isLastDay ? 0 : 1
          const date = new Date(year, month + (isLastDay ? 1 : 0), day)
          if (isLastDay ? date > startDate : date >= startDate) {
            dateRanges.push({ start: date, end: date })
          }
        }
      }
      return dateRanges
    },
    async setSeller(value) {
      const params = {
        country_id: this.formTableList.country.id
      }
      const queryParams = {
        search: value
      }
      return await this.baseService
        .callService('getSeller', queryParams, params)
        .then((resp) => {
          return resp.data.organizations.map((el) => ({
            ...el,
            text: el.fullname,
            valid: true
          }))
        })
        .catch((err) => {
          return err
        })
    },
    changeInitDate(name, value) {
      this.lastDays('lastDaysRanges', this.form.initDate)
    },
    changeRadioType(name, value) {
      delete this.form.idSeller
      delete this.form.file
      const hasIdSeller = this.m_getElementIndex(this.fields, 'name', 'idSeller') !== -1
      const haslabelFile = this.m_getElementIndex(this.fields, 'name', 'labelFile') !== -1
      const hasFile = this.m_getElementIndex(this.fields, 'name', 'file') !== -1
      if (value.id === 1) {
        if (!hasIdSeller) this.fields.push(this.fieldIdSeller)
        if (haslabelFile) this.fields.splice(this.m_getElementIndex(this.fields, 'name', 'labelFile'), 1)
        if (hasFile) this.fields.splice(this.m_getElementIndex(this.fields, 'name', 'file'), 1)
      } else {
        if (!haslabelFile) this.fields.push(this.labelFile)
        if (!hasFile) this.fields.push(this.fieldMasiveCharge)
        if (hasIdSeller) this.fields.splice(this.m_getElementIndex(this.fields, 'name', 'idSeller'), 1)
      }
      this.keyFormRender++
    },
    getCompaniesByPriceList(priceListId) {
      return this.companies.filter(company => company.price_list_id === priceListId)
    },
    getHTMLAlert() {
      let html = `
        <div class="pl-3 pr-2">
          <div id="price-lists-container">
      `
      this.priceLists.forEach(priceList => {
        html += `
            <div id="price-list-name-${priceList.id}" class="text-color-alert mt-1 mb-1">
              IDs eCommerce/Mkp en la lista ${priceList.name}
            </div>
            <div id="mkp-list-${priceList.id}" class="mkp-list text-color-alert">
              <span>
        `
        const companies = this.getCompaniesByPriceList(priceList.id)
        companies.forEach((company, index) => {
          html += `${company.company_id}-${company.company_name}`
          if (index < companies.length - 1) {
            html += ', '
          }
        })
        html += `
              </span>
            </div>
        `
      })
      html += `
          </div>
          <h4 class="mt-2 mb-2 text-color-alert">Indique qué desea hacer:</h4>
          <ul class="text-justify text-color-alert pr-3" >
            <li class="mb-1">Transferir empresas: Mueve todas las empresas cargadas al nuevo listado, eliminando las coincidentes del listado actual, a partir de la fecha seleccionada.</li>
            <li>Descartar cambios: No se asociará ninguna empresa cargada a la lista de precio seleccionada.</li>
          </ul>
        </div>
      `
      return html
    },
    async ok() {
      const isCheck = await this.$refs.formRenderAssociateList.onlyCheckForm()
      if (isCheck) this.validateAssociations()
    },
    getParams() {
      const params = {
        carrier_service_id: this.form.service.id,
        carrier_id: this.form.carrier.id,
        prices_list_id: this.form.row.id,
        start_date: dayjs(this.form.initDate).format('YYYY-MM-DD')
      }
      if (this.form.idSeller) params.company_id = this.form.idSeller.id
      if (this.form.file) params.file = this.form.file
      if (this.form.endDate) params.end_date = dayjs(this.form.endDate).format('YYYY-MM-DD')
      return params
    },
    async validateAssociations(data) {
      this.loading.associateList = true
      this.baseService.callUploadFileCustomParams('postValidateAssociations', this.getParams())
        .then((resp) => {
          if (resp.data.length) {
            this.priceLists = resp.meta.prices_list
            this.companies = resp.data
            this.setAlert()
          } else {
            this.associatePricesList()
          }
        })
        .catch((err) => {
          this.$newError('Ha ocurrido un problema', err.message, 'large')
        })
        .finally(() => {
          this.loading.associateList = false
        })
    },
    setAlert() {
      this.$confirm(this.$t(this.getHTMLAlert()),
        () => this.associatePricesList(),
        'Se detectaron empresas en otra lista',
        'Transferir empresas',
        'Descartar cambios',
        false,
        () => this.loading.associateList = false,
        550,
        '', '', '', '',
        'btn btn-customyesno-warning mr-1'
      )
    },
    associatePricesList() {
      this.loading.associateList = true
      const callServiceType = this.form.radioTypeCharge.id === 1 ? this.baseService.callService('putAssociatePricesLists', this.getParams()) : this.baseService.callUploadFileCustomParams('postBulkAssociatePricesLists', this.getParams())
      callServiceType
        .then(() => {
          this.$newSuccess('¡Se ha asociado la lista!', 'La lista ha sido asociada con éxito.')
        })
        .catch((err) => {
          this.$newError('Ha ocurrido un problema', err.message, 'large')
        })
        .finally(() => {
          this.loading.associateList = false
          this.close()
        })
    },
    close() {
      delete this.form.services
      delete this.form.idSeller
      this.$emit('closeModal', 'ModalAssociateList')
    }
  }
}
</script>
<style lang="scss">
  .mkp-list {
    border: 1px solid #D4D9DF;
    padding: 8px;
    text-align: left;
  }
  .text-color-alert {
    color: #6A6C6A !important;
    font-weight: 300;
  }
</style>
